module.exports = __webpack_public_path__ + "716aa3bcd74cf495b1fad4b44304cbba.pdf";